import type { DependencyList } from 'react';
import { useRef, useEffect } from 'react';
import isEqual from 'lodash/isEqual';

export function useDeepCompareEffect(
	callback: React.EffectCallback,
	dependencies: React.DependencyList,
) {
	const callbackRef = useRef(callback);
	callbackRef.current = callback;

	const memoizedDeps = useDeepCompareMemoize(dependencies);

	useEffect(() => callbackRef.current(), [memoizedDeps]);
}

function useDeepCompareMemoize(value: DependencyList) {
	const ref = useRef<DependencyList>();

	if (!isEqual(value, ref.current)) {
		ref.current = value;
	}
	return ref.current;
}
